import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getListQuanLyThuChiHopDong,
  updateDataSearch,
} from "../../../actions/QuanLyThuChiHopDong";
import { ModalSearchNangCaoMobile } from "./ModalSearchNangCaoMobile";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";

export const SearchBarMobile = ({ isHoaHongTraGop }) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiHopDong
  );

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const onSearch = () => {
    // console.log(dataSearch);
    dispatch(getListQuanLyThuChiHopDong(dataSearch));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: event,
        })
      );
      dispatch(getListQuanLyThuChiHopDong(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
        <div data-repeater-list="car">
          <div data-repeater-item className="">
            <form className="search-full form row bg-search-form form-mobile-search">
              <div
                className="text-right  search-p mb-1  "
                style={{ width: "100%" }}
              >
                <div className="row col-sm-12">
                  <div className="col-sm-8">
                    <div className="search-mobile-new">
                      <fieldset className="form-group position-relative mb-0">
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Mã hợp đồng, tên khách hàng"
                          value={dataSearch.ten}
                          onChange={updateTextValue("ten")}
                          onKeyDown={handleKeyDown}
                        />
                        <div
                          className="form-control-position"
                          onClick={onSearch}
                        >
                          <i className="mdi mdi-magnify"></i>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <a
                      href={() => false}
                      className="card-link blue darken-2 text-search-new"
                      style={{marginBottom:"-3px"}}
                      onClick={handleShow}
                    >
                      <i>
                        <PopoversBootrap
                          contentText="Tìm kiếm nâng cao"
                          trigger={["hover", "focus"]}
                          placement={"top"}
                        >
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/icon-fitter-v2.png"
                            alt=""
                            style={{
                              scale: "0.9",
                              verticalAlign: "sub",
                              marginTop: "-2px",
                            }}
                          />
                          {/* <i className="mdi mdi-download"></i> */}
                        </PopoversBootrap>
                      </i>
                    </a>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        {show && (
          <ModalSearchNangCaoMobile
            show={show}
            onHide={handleClose}
            isHoaHongTraGop={isHoaHongTraGop}
          />
        )}
      </div>
    </>
  );
};
